export const totalSteps = 10;

export const defaultFileSize = 2621440;
export const niumForexRequiredField = ['country', 'address1', 'address2', 'pin_code'];

export const screenSettings = {
  recipient: {
    stepNumber: 1
  },
  upload_documents: {
    stepNumber: 2
  },
  aadhar_verification: {
    stepNumber: 3
  },
  re_kyc: {
    stepNumber: 3
  },
  pan_verification: {
    stepNumber: 4
  },
  select_bank: {
    stepNumber: 5
  },
  e_sign_in: {
    stepNumber: 6
  },
  acknowledgement: {
    stepNumber: 8
  },
  transaction_summary: {
    stepNumber: 7
  },
  video_kyc: {
    stepNumber: 9
  }
};

export const RECIPIENT_SCREEN = {
  selectRecipient: {
    heading: 'Select recipient',
    subHeading: 'We only show recipients that receive {XXX}',
    addNewRecipient: 'Add new recipient'
  },
  addRecipient: {
    heading: 'Provide recipient information',
    subHeading: 'You don’t have any {XXX} recipients. Add a recipient to continue. ',
    addNewRecipient: 'Add new recipient',
    recipientInfo: 'Recipient info',
    recipientType: 'Recipient type',
    currency: 'Currency',
    recipientReceivingCountry: 'Recipient receiving country',
    relationWithRecip: 'Relationship with recipient',
    recipiFullName: 'Recipient full name',
    recipientBankDetails: 'Recipient bank details',
    swift: 'SWIFT',
    bankName: 'Bank name',
    bankAccountNumber: 'Bank account number',
    recipientAddress: 'Recipient address',
    countryOfResidence: 'Country of residence',
    enterAddressManually: 'Enter address manually',
    buttonMsg: 'Next',
    saveRecipient: 'Save recipient'
  }
};
export const UPLOAD_DOCUMENT_SCREEN = {
  uploadFemaDocuments: {
    heading: 'Upload documents',
    subHeading: 'We need the below documents to proceed with your transfer.',
    documentsPendingUpload: 'Documents pending upload',
    warningText: `You’ve made a similar transfer before, and you can reuse your uploaded documents.
    If any of your details have changed, please upload the new documents.`,
    button1: 'Use these documents',
    button2: 'Upload new documents'
  },
  documentUpload: {
    heading: 'Upload (PDF or image)',
    replace: 'Replace',
    submit: 'Submit'
  },
  passport: {
    submit: 'Submit'
  }
};
export const PAN_VERIFICATION_SCREEN = {
  heading: 'PAN card details',
  subHeading: 'Enter your PAN card number to proceed',
  panCardNumber: 'PAN card number',
  buttonMsg: 'Submit',
  defaultErrorMsg: 'Something went wrong',
  lengthError: 'Pan number should be 10 characters long.',
  accountHolderName: 'Account holder name (as per Aadhaar)',
  nameAsPerPanCard: 'Full name as per PAN card'
};

export const ACKNOWLEDGEMENT_SCREEN = {
  heading: 'Add Nium Forex as a beneficiary with your bank account',
  payWithBankTransfer: 'Pay with bank transfer',
  willReceive: 'will receive',
  bankTransferDetails: 'Bank transfer details',
  proceedButton: 'Proceed to video verification',
  alreadyMadePayment: `If you already made the payment, we should get it within 24-48 hours.
   As soon as we have it in our system, we'll process it promptly.`,
  goToHome: 'Go to home',
  videoVerificationText: 'Complete your video KYC before funding to avoid any cancellations'
};

export const E_SIGN_IN_SCREEN = {
  heading: 'E-sign transaction form',
  heading2: 'Review transaction form',
  subHeading: `We've got all your information for a seamless transfer. 
  Give it a quick once-over to make sure everything's on point. When you're ready, please e-sign the form.`,
  isReferralSubHeading: `The A2 transaction form will be emailed to your registered address. Please sign it, 
  and one of our representatives will collect the physical copy from you within 3 business days.`,
  buttonMsg: 'Proceed to e-sign',
  buttonProceed: 'Proceed'
};

export const CANCEL_PAYMENT_MODAL = {
  heading: 'Are you sure you want to exit?',
  subHeading:
    'If you exit now, your progress won’t be saved and you’ll have to start the transfer again.',
  subHeading48hrs:
    'If you exit now, your progress will be saved. You can continue the transfer within 48 hours.',
  confirmButtonMsg: 'Exit transfer',
  continueButtonMsg: 'Continue with this transfer'
};

export const RE_KYC_SCREEN = {
  heading: 'Verify your identity',
  subHeading: 'We retrieved your personal details from your last transfer. Did anything change?',
  remitterDetails: 'Remitter details',
  remitterAadhaarName: 'Name as per Aadhaar:',
  remitterPanName: 'Name as per Pan:',
  remitterAddress: 'Address of the remitter: ',
  remittePanNumber: 'PAN Number:',
  remitteAadhaarNumber: 'Aadhaar Number:',
  remitteDob: 'Date of birth:',
  primarySubmitBtn: 'My details are the same',
  secondrySubmitBtn: 'My details changed'
};
export const FUND_TRANSFER_MODAL = {
  heading: 'Fund your transfer',
  validFor: 'Valid for:',
  accNumber: 'Account Number',
  accName: 'Account Name',
  bankName: 'Bank Name',
  branch: 'Branch',
  txnNumber: 'Transaction Number',
  txnDetails: 'Enter this number in the description/remarks when making the payment',
  ifsc: 'IFSC code',
  infoTextPart1: 'Pay from your own',
  infoTextPart2: ' savings ',
  infoTextPart3:
    'bank account. If paid from another account, your transfer will be cancelled and refunded.'
};

export const FUND_YOUR_TRANSFER_SCREEN = {
  heading: 'Fund your transfer',
  headingVerify: 'Verifying your payment',
  transactionNumber: 'Transaction number',
  willReceive: 'will receive',
  alreadyPaidInfo: `If you've already paid, your transaction will be processed after verification. 
    You'll be notified once the money has reached your recipient's account, usually within 2-3 business days.`,
  depositMoney: 'Deposit money',
  ignoreIfPaid: 'Ignore if paid already',
  paymentInfoBtn: 'Payment instructions',
  gotoHomeBtn: 'Go to home',
  MODAL: {
    heading: 'Have you made the payment?',
    body: 'Ensure the payment is completed within XX hours, or your transfer will be canceled.',
    gotIt: 'Got it'
  },
  a2FormMessage: `The A2 transaction form will be emailed to your registered address. Please sign it, 
  and one of our representatives will collect the physical copy from you within 3 business days.`
};

export const SELECT_BANK_SCREEN = {
  heading: 'Paying for your transfer',
  subHeading: `Please use a savings bank account in your name only. 
  Transfers from other accounts will be cancelled and refunded. Joint accounts are not accepted.`,
  accHolderName: 'Account holder name (as per Aadhaar)',
  bankName: 'Select bank name',
  accNumber: 'Account number',
  note: 'Add a note (optional)',
  noteToolTip: `This information will be visible on your payment receipt. 
  You can mention your payment reason/ university reference number/ student ID or invoice number.`,
  btnText: 'Next'
};

//Redux Forms for NIUM-Forex
export const ADD_RECIPIENT = 'addRecipientForm';

export const AADHAR_VERIFICATION = {
  varifyAadhar: 'Verify your Aadhaar',
  digiLockerConsent:
    'We will use DigiLocker for this verification. You will be directed to another screen to complete this step.',
  proceedToAadharVerification: 'Proceed to Aadhaar verification',
  aadharMobileNotLinked: 'Your Aadhaar and mobile not linked?',
  aadharNotLinked: 'Your Aadhaar and mobile not linked?',
  linkAadhar: ` Link your Aadhaar to your mobile number at the nearest enrolment 
  centre and verify with an OTP sent to you. For details visit uidai.gov.in.`,
  setUpTransfer: 'After verification, set up your transfer.',
  gotIt: 'Got it',
  aadharNumberIssue: 'There was an issue with retrieving your details',
  aadharNumberMismatch: 'Oops! There was an issue with the Aadhaar number provided',
  tryAgainAadharVerification: 'Please double-check your number and try again.',
  tryAgain: 'Try again',
  aadharVerified: 'Aadhaar verified successfully',
  redirectShortly: 'You’ll be redirected shortly.',
  fetchingAadharDetails: 'Please wait while we fetch your details',
  dontCloseWindow: 'Don’t close this window, you will be redirected shortly.'
};

export const PAN_VERIFICATION_FORM = 'panVerificationForm';
export const COUPON_FORM_NAME = 'applyCouponFormPaymentReview';
export const SELECT_BANK_FORM = 'selectBankForm';
export const NIUM_FOREX_CALCULATOR_FORM = 'niumForexCalculatorForm';
export const PASSPORT_FORM = 'passportForm';

export const SEND_MONEY_CALCULATOR_SCREEN = {
  heading: 'Send money to 60+ countries',
  youSend: 'You send',
  setUpNewTransfer: 'Set up transfer',
  recipientReceives: 'Recipient receives',
  provideTransferInfo: 'Provide transfer related information',
  selectReasonForTransfer: 'Select reason for transfer to see required supporting documents',
  tax: 'Tax* ',
  taxInfo: `Includes mandatory State goods and services tax (SGST) and Central goods and services tax (CGST).`,
  additionalCharges: 'Additional charges',
  details: 'Details',
  youPayExactly: 'You pay exactly',
  swiftFees: `*We have calculated TCS charges based on your activity with Instarem, 
  but these could change if you have used other remittance services.`,
  inProgressTransaction: `Incomplete or ongoing transfer`,
  sourceOfFunds: 'Source of funds',
  reasonForTransfer: 'Reason for transfer',
  remittanceType: 'Who is the student?',
  bankTransfer: 'BANK_TRANSFER',
  transactionFees: 'Transaction fee',
  bankTransferLabel: 'Bank Transfer',
  receivingMethodFee: 'Receiving method fee',
  vKYCPendingModal: {
    modalHeading: 'You have an ongoing transaction',
    modalSubHeading:
      'Please complete your video verification to proceed with your ongoing transaction.',
    btnText: 'Complete video verification'
  },
  disclaimerInfo: {
    mustBeInIndia: `You must be in India `,
    locationDisclaimer: `during the verification call to successfully complete the vKYC process. 
    We will not be able to proceed with the vKYC if you are registering from outside of India.`
  },
  vkycRenewalMessage: `It’s time to renew your KYC verification. To proceed with your transfer, 
    please complete the verification process in the next steps.`,
  payingForSomeOneElseText: `You can only transfer funds for your spouse’s, or 
  blood relative’s education (spouse, child, sibling). Transfers for other relatives or friends' education are not allowed.`,
  swiftCharges:
    'SWIFT charges apply and will be deducted from the final amount your recipient gets.'
};

export const reasonForTransferMessages: Record<any, any> = {
  RFT001: `You’ll need to upload student’s passport, university offer letter, education visa or an alternative. You may be asked  
    to upload some other documents.`,
  RFT002: `You’ll need to upload student’s passport, university offer letter, 
  education visa or an alternative. You may be asked  to upload some other documents.`,
  RFT005:
    'You’ll need to upload your passport, employment offer letter. You may be asked  to upload some other documents.',
  RFT006: 'You’ll need to upload your passport and visa fee invoice.'
};

export const DETAILS_SCREEN = {
  transactionDetails: 'Transaction details',
  transferDetails: 'Transfer Details',
  send: 'Send',
  totalFees: 'Total fees',
  transactionFees: 'Transaction fee',
  bankFees: 'Bank transfer fee',
  bankDepositFees: 'Bank deposit fee',
  amountToConvert: 'Amount to convert',
  exchangeRate: 'Exchange rate',
  recipientGets: 'Recipient gets',
  amountPayable: 'Amount payable',
  tax: 'Tax*',
  tcs: 'Tax collection at source',
  youPayExactly: 'You pay exactly',
  cgstNetFee: 'CGST on Net Fee Tax',
  SgstNetFee: 'SGST on Net Fee Tax',
  CgstTransactionFee: 'CGST on Transaction Fee Tax',
  SgstTransactinFee: 'SGST on Transaction Fee Tax',

  SgstCalculationDisclaimer: `The calculation of State Goods and
     Services Tax (SGST) will be based on the state information available in the Aadhaar address provided`,
  gstCalculatorPaymentReview: `*We have calculated TCS charges based on your activity with Instarem, but these could change if 
  you have used other remittance services. 
  To make sure your recipient receives the full amount, we have also applied a flat SWIFT fee.`,
  appliedDiscount: 'Applied discount'
};

export const STEPS_VIDEO_KYC_IN_COMPLETE = [
  { heading: 'Create', subheading: 'Enter sending amount and recipient’s details' },
  { heading: 'Upload', subheading: 'Provide supporting documents' },
  { heading: 'Verify', subheading: 'Provide Aadhaar and PAN numbers' },
  { heading: 'Deposit', subheading: 'Fund your transfer through Nium Forex bank account' },
  { heading: 'Complete', subheading: 'Talk to our agent for video verification' }
];

export const STEPS_VIDEO_KYC_COMPLETED = [
  { heading: 'Create', subheading: 'Enter sending amount and recipient’s details' },
  { heading: 'Upload', subheading: 'Provide supporting documents' },
  { heading: 'Verify', subheading: 'Provide Aadhaar and PAN numbers' },
  { heading: 'Deposit', subheading: 'Fund your transfer through Nium Forex bank account' }
];

export const CANCEL_EXISTING_PENDING_TRANSACTION_MODAL = {
  heading: 'Incomplete transfer detected',
  subHeading: `You can only have one incomplete transfer at a time.
     If you proceed to set up a new one, your existing incomplete transfer will be discarded.`,
  discardAndRestart: 'Discard & restart',
  goBack: 'Go back'
};

export const AADHAR_RETRY_COUNT = 'AADHAR_RETRY_COUNT';

export const TRANSACTION_HISTORY_CONST = {
  videoVerification: {
    header: 'Completing video verification is mandatory for processing your transfers',
    subHeader: 'If you already made the payment, we should get it within 24-48 hours',
    buttonText: 'Complete video verification'
  },
  paymentInfo: `If you already made the payment, we should get it within 24-48 hours. 
  As soon as we have it in our system, we'll process it promptly.`
};

export const VIDEO_KYC = {
  heading: 'Video verification call',
  subHeading: 'Keep your PAN card handy while talking with a Nium Forex representative.',
  validFor: 'Valid for:',
  keepPanCardHandy: `Keep your PAN card handy while talking with a Nium Forex representative.`,
  kycInfo: `Click 'Allow' for location, camera, and microphone permissions for Video verification as per RBI guidelines. 
  Please note that the transaction will be auto-cancelled if payment is
   not made and Video verification is not completed within the valid time.
    In case of incomplete Video verification, the payment made will be refunded.`,
  startVideoverification: 'Start video verification',
  videoKycFailure: {
    heading: 'Your video verification is unsuccessful',
    subHeading: 'Please try again and complete your video verification.',
    tryAgainVideoKyc: 'Try again'
  },
  videoKycInProgress: {
    heading: 'Your video verification is still under review',
    subHeading: '',
    gotIt: 'Got it'
  },
  videoKycRejection: {
    heading: 'Identity verification failed',
    subHeading: `We could not verify your identity during the video verification stage. 
    We encourage you to consider initiating a new transfer, making sure that all the details you provide are accurate and complete.`,
    startOver: 'Start over'
  },
  validTime: `XXh 00m 00s`,
  mustBeInIndia: `You must be in India `,
  locationDisclaimer: `during the verification call to successfully complete the vKYC process. 
  We will not be able to proceed with the vKYC if you are registering from outside of India.`
};

export const TRANSACTION_SUMMARY_SCREEN = {
  header: `Transfer summary`,
  subHeading: `Review the transfer summary and authorise the transfer`,
  btnAuthoriseMessage: `Authorise transfer`,
  couponCode: {
    heading: 'Apply coupon',
    placeHolder: 'Enter coupon code'
  },
  recipientInfo: {
    heading: 'Recipient info'
  },
  errors: {
    invalidCoupon: 'This code is not valid'
  }
};

export const STUDENT_ARRAY = ['RFT002', 'RFT001'];
export const NIUM_FOREX_CURRENT_SCREEN = 'NIUM_FOREX_CURRENT_SCREEN';
export const TRANSACTION_ID = 'transactionId';
export const COMPUTE_API_ERROR_MESSAGES = [
  'Transaction configuration does not exist for given pair'
];

export const SECONDARY_ROUTING_CODE_PLACEHOLDER = {
  TRANSIT_NUMBER: 'Transit number',
  BSB: 'BSB',
  SORT_CODE: 'Sort code',
  IBAN: 'IBAN',
  ACH: 'ACH (ABA routing)'
};

export const REMITTANCE_TYPE_CODE = 'RT002';

export const ERROR_DOC_EXPIRED_MESSAGE = 'Document expired/not valid anymore!';
